import { useState } from 'react';
import { downloadBase64AsPDF } from '@ibk/shared-utils';
import { useGenerateEmissorOrderReportPdfMutation, } from '../services/contractOrderReportApi';
export function useEmissorOrderReportPdf() {
    const [trigger] = useGenerateEmissorOrderReportPdfMutation();
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    async function fetchReport(params, filename) {
        setIsError(false);
        setIsLoading(true);
        try {
            const base64 = await trigger(params).unwrap();
            if (base64) {
                downloadBase64AsPDF(base64, filename);
            }
        }
        catch {
            setIsError(true);
        }
        finally {
            setIsLoading(false);
        }
    }
    return {
        isError,
        isLoading,
        fetchReport,
    };
}
